<script lang="ts">
	import type { Snippet } from 'svelte'
	import Modal from '../Modal.svelte'
	import { Button, ButtonType, ButtonSize, LoadingSpinner } from '@repo/commons/components'

	interface Props {
		visible?: boolean
		title?: string
		message?: string
		content?: Snippet
		confirmText?: string
		cancelText?: string
		isLoading?: boolean
		confirmButtonType?: ButtonType
		onconfirm?: (() => void) | null
		oncancel?: (() => void) | null
		onclose?: (() => void) | null
	}

	let {
		visible = false,
		title = 'Confirm Action',
		message = 'Are you sure you want to continue?',
		content = undefined,
		confirmText = 'Confirm',
		cancelText = 'Cancel',
		isLoading = false,
		confirmButtonType = ButtonType.BRAND,
		onconfirm = null,
		oncancel = null,
		onclose = null
	}: Props = $props()

	const handleConfirm = () => {
		onconfirm?.()
		onclose?.()
	}

	const handleCancel = () => {
		oncancel?.()
		onclose?.()
	}

	const handleClose = () => {
		oncancel?.()
		onclose?.()
	}
</script>

<Modal
	{visible}
	{title}
	showCloseButton={false}
	closeOnBackdropClick={false}
	onclose={handleClose}
	styleProps="max-width: 500px; width: 90vw;"
>
	{#snippet children()}
		<div class="confirmation-content">
			{#if isLoading}
				<div class="w-full h-full flex justify-center items-center">
					<LoadingSpinner size={48} color="#007ACC" />
				</div>
			{:else if content}
				{@render content()}
			{:else}
				<p class="message">{message}</p>
			{/if}

			<div class="button-group">
				<Button
					disabled={isLoading}
					buttonText={confirmText}
					buttonType={confirmButtonType}
					buttonSize={ButtonSize.LARGE}
					onclick={handleConfirm}
				/>
				<Button
					disabled={isLoading}
					buttonText={cancelText}
					buttonType={ButtonType.TERTIARY_INVERSE}
					buttonSize={ButtonSize.LARGE}
					onclick={handleCancel}
				/>
			</div>
		</div>
	{/snippet}
</Modal>

<style>
	.confirmation-content {
		@apply flex flex-col gap-6;
		min-height: 120px;
	}

	.message {
		@apply text-base text-[#001D33B2] leading-relaxed;
		margin: 0;
	}

	.button-group {
		@apply flex gap-4;
		margin-top: auto;
	}
</style>
